export default __webpack_public_path__ + "static/media/mapPin_active.a019627c.svg";